const initState = {
  leftMenuSidebarVisible: false
};

export const LEFTMENUSIDEBAR_VISIBLE_UPDATE = 'LEFTMENUSIDEBAR_VISIBLE_UPDATE';
export const updateLeftMenuSidebarVisible = (val) => ({type: LEFTMENUSIDEBAR_VISIBLE_UPDATE, payload: val});

export default (state = initState, action) => {
  switch (action.type) {
    case LEFTMENUSIDEBAR_VISIBLE_UPDATE:
      return {...state, leftMenuSidebarVisible: action.payload};
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/reducers/leftMenuSidebarReducer.js